export default function formatInteger(value) {
  if (value < 1000) {
    return `${value}`;
  }

  const thousands = Math.floor(value / 1000);
  const remainder = value - thousands * 1000;
  const remainderStr = `${remainder}`.padStart(3, '0');

  return `${thousands},${remainderStr}`;
}



// WEBPACK FOOTER //
// ./src/helpers/formatInteger.js